import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import * as S from './styled';

export const TagBeta = () => {
    const { t } = useTranslation();

    return (
        <S.Container>
            <Text type="small-text" bold color="decorative-c">
                {t('basics.beta').toUpperCase()}
            </Text>
        </S.Container>
    );
};
